<template>
    <section class="dark">
        <section class="content-box">
            <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate" @changeCompareDate="changeCompareDate"></title-date-component>
            <section class="data-box">
                <nav-component :type="type" style="margin-top:30px;" :currentType="currentType" @changeNavType="changeNavType"></nav-component>
                <line-component style="height:320px; margin-top:50px;" :resultData="resultData"></line-component>
            </section>
        </section>
        <section class="close-btn" @click="closeTc"></section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .dark {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 3;
        > .content-box {
            width: 90%;
            max-height: 90%;
            min-height: 50%;
            padding: 30px;
            background-color: #FFF;
            border-radius: 2px;
            overflow-x: hidden;
            overflow-y: auto;
        }
        > .close-btn {
            width: 15px;
            height: 15px;
            background: url(~static/img/close.png) no-repeat center center;
            background-size: cover;
            position: absolute;
            right: 2%;
            top: 12%;
            cursor: pointer;
        }
    }
</style>

<script>
    import TitleDateComponent from '../../components/title-date/TitleDate.vue'
    import NavComponent from '../../components/nav/Nav.vue'
    import LineComponent from '../../components/echarts/Line.vue'
    import menpiaoDataPlatform from 'api/menpiaoDataPlatform'
    import { eventBus } from 'helpers/index'

    export default {
        components: {
            TitleDateComponent,
            NavComponent,
            LineComponent
        },
        data () {
            return {
                titleOption: {
                    title: this.productName,
                    dateRangeSelect: true,
                    dateMaxRangeLength: 60, // 日期区间最大跨度
                    dateCompareSelect: true,
                    showDate: {
                        startDate: this.startDateParams,
                        endDate: this.endDateParams
                    }
                },
                type: [
                    {
                        name: '销量',
                        value: 'payQuantity'
                    },
                    {
                        name: '销售额',
                        value: 'payAmount'
                    },
                    {
                        name: '浏览量',
                        value: 'intentionPV'
                    },
                    {
                        name: '访客量',
                        value: 'intentionUV'
                    },
                    {
                        name: '访购率',
                        value: 'visitPurchaseRate'
                    },
                    {
                        name: '下单用户数',
                        value: 'orderUserNum'
                    },
                    {
                        name: '支付用户数',
                        value: 'payUserNum'
                    },
                    {
                        name: '客单价',
                        value: 'customerPrice'
                    }
                ],
                currentType: 'payQuantity', // 当前纬度
                date: {
                    startDate: this.startDateParams,
                    endDate: this.endDateParams
                },
                initDateRange: this.startDateParams + ' ~ ' + this.endDateParams,
                typeData: {
                    allTypeData: {  // 所有维度数据
                        payQuantity: [],
                        payAmount: [],
                        intentionPV: [],
                        intentionUV: [],
                        visitPurchaseRate: [],
                        orderUserNum: [],
                        payUserNum: [],
                        customerPrice: []
                    },
                    allTypeCompareData: {   // 所有对比纬度数据
                        payQuantity: [],
                        payAmount: [],
                        intentionPV: [],
                        intentionUV: [],
                        visitPurchaseRate: [],
                        orderUserNum: [],
                        payUserNum: [],
                        customerPrice: []
                    }
                },
                resultData: {
                    dateArr: [],
                    dataArr: [],
                    dateCompareArr: [],     // 对比日期
                    dataCompareArr: [],     // 对比数据
                    currentTypeName: '销量'
                }
            }
        },
        props: ["salePlatform", "productId", "productName", "startDateParams", "endDateParams"],
        methods: {
            // 关闭弹层
            closeTc: function () {
                eventBus.$emit('closeTc');
            },

            // 获取单品数据
            getData (isCompare, date) {
                this.isLoading = true;
                menpiaoDataPlatform.getProductData(this.salePlatform, date.startDate, date.endDate, this.productId, true)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = (res.data.length === 0 || res.data[0].daily === null) ? [] : res.data[0].daily;
                            this.formatAllData(data, isCompare);
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        if (isCompare === true) {
                            this.resultData.dateCompareArr = [];
                            this.resultData.dataCompareArr = [];
                        } else {
                            this.resultData.dateArr = [];
                            this.resultData.dataArr = [];
                        }
                        console.log(err);
                        this.isLoading = false;
                    })
            },

            formatAllData (data, isCompare) {
                let date = [];
                let initData = {
                    payQuantity: [],
                    payAmount: [],
                    intentionPV: [],
                    intentionUV: [],
                    visitPurchaseRate: [],
                    orderUserNum: [],
                    payUserNum: [],
                    customerPrice: []
                };
                data.forEach((item) => {
                    date.push(item.date);
                    initData.payQuantity.push(item.payQuantity);
                    initData.payAmount.push(item.payAmount);
                    initData.intentionPV.push(item.intentionPV);
                    initData.intentionUV.push(item.intentionUV);
                    initData.visitPurchaseRate.push(item.visitPurchaseRate);
                    initData.orderUserNum.push(item.orderUserNum);
                    initData.payUserNum.push(item.payUserNum);
                    initData.customerPrice.push(item.customerPrice);
                })
                if (isCompare === true) {
                    this.typeData.allTypeCompareData = initData;
                    this.$set(this.resultData, 'dateCompareArr', date);
                    this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
                } else {
                    this.typeData.allTypeData = initData;
                    this.$set(this.resultData, 'dateArr', date);
                    this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
                }
            },

            // 切换类型
            changeNavType (type) {
                this.currentType = type;
                let currentTypeName = this.type.find((item) => {
                    return item.value === this.currentType;
                });
                this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
                this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
                this.$set(this.resultData, 'currentTypeName', currentTypeName.name);
            },

            // 切换日期
            changeDate (params) {
                this.date.startDate = params.dateRange.startDate;
                this.date.endDate = params.dateRange.endDate;
                this.getData(false, this.date);
            },

            // 切换对比日期
            changeCompareDate (params) {
                if (params.dateRange.startDate === '' || params.dateRange.endDate === '') {
                    this.resultData.dateCompareArr = [];
                    this.resultData.dataCompareArr = [];
                    return;
                }
                this.getData(true, params.dateRange);
            }
        },
        created () {
            this.getData(false, this.date);
        }
    }
</script>



// WEBPACK FOOTER //
// Tc.vue?6a698a5e